export const proNamePath = ['steamAccount', 'proSteamAccount', 'name'];
export const namePath = ['steamAccount', 'name'];
